// src/pocketbaseClient.js
import PocketBase from 'pocketbase';

// Initialize the PocketBase client with your PocketBase backend URL
const pb = new PocketBase('https://ahmed.pockethost.io');

export default pb;
